module.exports = __webpack_public_path__ + "img/wonju_pop2.92c928c2.jpg";